import { gql } from "lib/apolloClient";
import { workflowProgressFragment } from "Workflows/modules/WorkflowsFragments";

export const executionStatusFragment = {
  executionStatus: gql`
    fragment executionStatus on SyncExecutionStatus {
      percentageComplete
    }
  `,
};

export const staffFragment = {
  basicStaffDetails: gql`
    fragment staffItem on Staff {
      id
      firstName
      middleName
      lastName
      profileImage
      email
      type
      showPitchScreen
      role
      showClassSelectionScreen
      showBifurcationScreen
      isDevUser
      isArchived
      entityTags {
        id
        key
        value
      }
    }
  `,
};

export const jobDataFragment = {
  jobData: gql`
    fragment jobData on IntegrationJob {
      id
      status
      serviceName
      createdAt
      curriculum
      curriculumId
      isLatest
      type
      metadata
      academicYear {
        id
      }
      subTasksFeed(filters: $subTaskFilters) @include(if: $fetchSubTasksCount) {
        totalCount
        edges @include(if: $fetchSubtaskEdges) {
          node {
            id
            status
            parsedData
          }
        }
        errorCount
      }
      createdBy {
        ...staffItem
      }
      executionStatus {
        ...executionStatus
      }
      workflowProgress @include(if: $fetchWorkflowProgress) {
        ...workflowProgress
      }
    }
    ${staffFragment.basicStaffDetails}
    ${executionStatusFragment.executionStatus}
    ${workflowProgressFragment.workflowProgress}
  `,
  basicJobData: gql`
    fragment basicJobData on IntegrationJob {
      id
      status
      serviceName
      createdAt
      isLatest
      type
      metadata
      createdBy {
        ...staffItem
      }
    }
    ${staffFragment.basicStaffDetails}
  `,
};

export const jobFeedFragment = {
  organizationJobFeedEdge: gql`
    fragment organizationCourseFeedEdgeItem on Organization {
      id
      jobFeed(
        first: $first
        afterV2: $afterV2
        academicYearState: $academicYearState
        filters: $filters
        curriculumProgramId: $curriculumProgramId
      ) {
        totalCount
        edges {
          node {
            ...jobData
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
    ${jobDataFragment.jobData}
  `,
};

export const subTaskDataFragment = {
  subTask: gql`
    fragment subTaskData on IntegrationSubTask {
      id
      parsedData
      type
      status
      isArchived
      hasError
      createdAt
    }
  `,
};

export const subTaskFeedFragment = {
  subTaskFeedEdge: gql`
    fragment subTaskFeedEdgeItem on IntegrationJob {
      id
      subTasksFeed(first: 200000, filters: $filters) {
        edges {
          node {
            ...subTaskData
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
    ${subTaskDataFragment.subTask}
  `,
};
